

















import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'SurveyResponseTitleCellPresenter',
  computed: {
    ...mapGetters(['featureFlags']),
    value(): string {
      return this.$attrs.data && this.$attrs.data.value;
    },
    shouldDisplayLink(): boolean {
      if (!this.featureFlags.vendor_risk_phase_1) {
        const status: string = this.$attrs.row.status.value;
        return status === 'Completed';
      }
      return true;
    },
    link(): string {
      const publicId: string = this.$attrs.row.publicId.value;
      if (this.featureFlags.vendor_risk_phase_1) {
        return `/sor/info/SurveyResponse/${this.$attrs.row.dbId}/info`;
      }
      return `/survey/review/${publicId}`;
    },
  },
});
